angular.module('offers', ['core', 'product', 'units', 'tax', 'deliverymethods', 'paymentmethods', 'execution-deadline', 'paymentdeadlines', 'clients', 'currency', 'files'])
    .factory('Offer', function ($resource) {
        return $resource('/crm/api/offers/:id', {}, {
            remove: {method: 'DELETE'},
            get: {method: 'GET'},
            update: {method: 'PUT'},
            sendEmail: {method: 'POST'},
            table: {method: 'GET', isArray: false, url: '/crm/api/offers/table'}
        });
    })
    .factory('OfferItem', function ($resource) {
        return $resource('/crm/api/offers/:id/items/:item', {id: '@id', item: '@item'}, {
            update: {method: 'PUT'},
            save: {method: 'POST'},
            remove: {method: 'DELETE'},
        });
    })
    .service('OfferService', function ($rootScope, modals, Offer) {
        this.remove = item => {
            return modals.confirmDelete(item.topic, () => Offer.remove({id: item.id}, () => $rootScope.$broadcast('offer.updated')).$promise);
        };
    })
    .service('OfferPrintFieldsService', function ($cookies) {
        this.showPrintFields = getBooleanFromCookies() || false;
        this.toggle = ()=> {
            this.showPrintFields = !this.showPrintFields;
            putCookieValFromBoolean(this.showPrintFields);
        };

        function putCookieValFromBoolean(booleanVal) {
            if (booleanVal) {
                $cookies.put("offer-show-print-fields", 1);
            } else {
                $cookies.put("offer-show-print-fields", 0);
            }
        }

        function getBooleanFromCookies() {
            return Number($cookies.get("offer-show-print-fields")) === 1;
        }
    })
    .factory('MailPriority', function ($resource) {
        return $resource('/crm/api/mail/priorities');
    })
    .service('OfferReportingService', function ($rootScope, $http, $q) {
        function loadOfferTemplates() {
            return $http.get('/crm/api/reporting/offer/templates').then(success => success.data, error => $q.reject(error.data || []));
        }

        function sendOfferEmail(offer, message) {
            return $http.post('/crm/api/reporting/offer/' + offer.id + "/email", message).then(success => success.data);
        }

        function getOfferFilesToSend(offer, language_code) {
            return $http.get('/crm/api/reporting/offer/' + offer.id + "/files?language=" + language_code).then(success => success.data);
        }

        return {
            loadOfferTemplates: loadOfferTemplates,
            sendOfferEmail: sendOfferEmail,
            getOfferFilesToSend: getOfferFilesToSend
        };

    })
    .service('OfferFormHelper', function (toastr, $filter, $translate, ProductSubstituteService) {
        this.onProductChanged = (offer, item, product)=> {
            if (!product)
                return;
            let ofh = this;
            ProductSubstituteService.findAndChange(item.product, offer.language.code)
                .then(result => {
                    item.product = result;
                    let orderedProduct = product.symbol;
                    product = result;
                    let description = product.description.map[offer.language.code] !== null ? product.description.map[offer.language.code] : "";
                    product.description.map[offer.language.code] = $translate.instant("substitute.replacement-for." + offer.language.code) + " " + orderedProduct + "\n" + description;
                    ofh.updateOfferItem(offer, item, product);
                }, () => {

                });
            ofh.updateOfferItem(offer, item, product);
        };
        this.updateOfferItem = (offer, item, product) => {
            item.unit = product.unit;
            item.taxRate = product.tax;
            if (angular.isDefined(product.netPriceBaseCurrency) && offer.currency && offer.currency.currencyCode === product.netPriceBaseCurrency.currencyCode) {
                item.netPriceBase = product.netPriceBase;
            } else {
                item.netPriceBase = 0;
                toastr.warning('Waluta ceny bazowej towaru (' + product.symbol + ') jest inna niż waluta oferty', 'UWAGA', {
                    closeButton: true,
                    timeOut: 6000
                });
            }

            this.netPriceBaseChanged(offer, item);

            if (!offer.language) {
                toastr.error('Nie wybrano języka oferty jest inna niż waluta oferty', 'UWAGA', {
                    closeButton: true,
                    timeOut: 6000
                });
            }

            if (product.name)
                item.productName = product.name.map[offer.language.code];

            if (product.description)
                item.productDescription = product.description.map[offer.language.code];
            else {
                item.productDescription = "";
            }
        }

        this.netPriceBaseChanged = (offer, item)=> {
            item.netPrice = Math.round(item.netPriceBase * 100 * (1 - Number(item.discount) / 100)) / 100;
            this.recalculateOffer(offer);
        };
        this.netPriceChanged = (offer, item)=> {
            item.netPriceBase = Math.round(item.netPrice * 100 / (1 - Number(item.discount) / 100)) / 100;
            this.recalculateOffer(offer);
        };

        this.addNewItem = (defaultNewItem, offer, isEditable) =>{
            let newItem = {
                quantity: 1,
                netPrice: 0,
                netPriceBase: 0,
                discount: 0,
                grossPrice: 0,
                totalNet: 0,
                totalNetBase: 0,
                totalGross: 0
            };
            angular.extend(newItem, defaultNewItem);
            if (isEditable)
                newItem.old = true;
            offer.items.push(newItem);
            this.recalculateOffer(offer);
        };

        this.recalculateOffer = offer => {
            let totalNet = Number(0);
            let totalNetBase = Number(0);
            let totalGross = Number(0);
            let totalDiscount = Number(0);
            angular.forEach(offer.items, item => {
                item.totalNet = Math.round(item.quantity * item.netPrice * 100) / 100;
                item.totalNetBase = Math.round(item.quantity * item.netPriceBase * 100) / 100;
                item.totalGross = Math.round(item.totalNet * 100 * (1 + (item.taxRate ? item.taxRate.value : 0))) / 100;
                totalNet += item.totalNet;
                totalNetBase += item.totalNetBase;
                totalGross += item.totalGross;
                totalDiscount += Math.round(item.totalNetBase * 100 - item.totalNet * 100) / 100;
            });
            offer.totalNet = totalNet;
            offer.totalNetBase = totalNetBase;
            offer.totalGross = totalGross;
            offer.totalDiscount = totalDiscount;
            offer.totalDiscountPercent = Math.round(totalDiscount * 100 / totalNetBase * 100) / 100;
        };
    })
    .controller('OfferFormController', function ($scope, $rootScope, $location, $filter, Offer, OfferStatus, PaymentDeadline, DeliveryMethod, ExecutionDeadline, PaymentMethod, Currency, Client, Numeration, Language, entity, toastr, ClientService, Product, Tax, Unit, OfferFormHelper) {
        $scope.offer = entity
        $scope.defaultNewItem = {}

        $scope.OfferFormHelper = OfferFormHelper
        $scope.tinymceOptionsSimple = {
            // height: 250,
            statusbar: true,
            plugins: "textcolor code",
            toolbar1: "bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | forecolor backcolor | fontsizeselect | code",
            toolbar2: "",
            toolbar_items_size: 'small'
        }

        $scope.removeItem = (offer, index) => {
            offer.items.splice(index, 1)
            OfferFormHelper.recalculateOffer(offer)
        }

        if (entity.client) {
            loadAddresses(entity.client)
            loadContacts(entity.client)
        }
        loadRequiredData(entity)

        $scope.onLanguageChanged = language => {
            $scope.offer.language = language;
        }

        function loadRequiredData(offer) {
            if (offer.id === null) {
                OfferFormHelper.recalculateOffer(offer)
                Numeration.nextNumber({clazz: "pl.multisoft.document.offer.Offer"}).$promise.then(result => offer.number = result.number)
            }

            Currency.query().$promise.then(items => {
                $scope.currencies = items
                if (offer.id === null && !offer.currency) {
                    offer.currency = Currency.getDefault(items)
                }
            })

            OfferStatus.query().$promise.then(items => $scope.statuses = items)

            DeliveryMethod.query().$promise.then(items => {
                $scope.deliverymethods = items
                if (offer.id === null && !offer.deliveryMethod) {
                    offer.deliveryMethod = items.find(item => item.defaultValue === true)
                }
            })

            PaymentDeadline.query().$promise.then(items => {
                $scope.paymentDeadlines = items
                if (offer.id === null && offer.paymentDeadline) {
                    offer.paymentDeadline = items.find(item => item.defaultValue === true);
                }
            })

            ExecutionDeadline.query().$promise.then(items => {
                $scope.executionDeadlines = items
                if (offer.id === null && !offer.executionDeadline) {
                    offer.executionDeadline = items.find(item => item.defaultValue === true);
                }
            })

            PaymentMethod.query().$promise.then(items => {
                $scope.paymentmethods = items
                if (offer.id === null && !offer.paymentMethod) {
                    offer.paymentMethod = items.find(item => item.defaultValue === true);
                }
            })
        }

        $scope.onClientChanged = $client => {
            refreshAddresses($client)
            refreshContacts($client)
            setPaymentSettings($client)
            delete $scope.offer.deliveryAddress
            delete $scope.offer.contact
        }

        Tax.query().$promise.then(items => {
            $scope.taxRates = items
            $scope.defaultNewItem.taxRate = items.find(item => item.defaultValue === true)
        })
        Unit.list().$promise.then(items => {
            $scope.units = items
            $scope.defaultNewItem.unit = Unit.getDefault(items)
        })
        $scope.refreshProducts = (q, language) => {
            Product.autocomplete(q, 100, language).then(items => $scope.products = items)
        }

        function refreshAddresses(client) {
            return loadAddresses(client).then(items => {
                if ($scope.offer.id === null) {
                    $scope.offer.deliveryAddress = items.find(i => i.defaults === true)
                }
            })
        }

        function refreshContacts(client) {
            return loadContacts(client).then(items => {
                if ($scope.offer.id === null) {
                    $scope.offer.contact = items.find(i => i.defaults === true)
                }
            })
        }
        $scope.save = () => {
            let promise
            if ($scope.offer.id !== null) {
                promise = Offer.update($scope.offer).$promise
            } else {
                promise = Offer.save($scope.offer).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast('offer.updated')
                toastr.success("Zapisano")
                $location.path("/offers/" + result.id)
            })
        }
        function setPaymentSettings(client) {
            if (angular.isDefined(client)) {
                Client.get({id: client.id}).$promise.then(function (clientDetails) {
                    if (angular.isDefined(clientDetails.paymentMethod) && clientDetails.paymentMethod !== null) {
                        $scope.offer.paymentMethod = clientDetails.paymentMethod;
                    }
                    if (angular.isDefined(clientDetails.paymentDeadline) && clientDetails.paymentDeadline !== null) {
                        $scope.offer.paymentDeadline = clientDetails.paymentDeadline;
                    }
                });
            } else {
                delete $scope.offer.paymentMethod;
                delete $scope.offer.paymentDeadline;
            }
        }

        function loadAddresses(client) {
            return Client.addresses({id: client.id}).$promise.then(items => {
                $scope.addresses = items;
                return items;
            })
        }

        function loadContacts(client) {
            return Client.contacts({id: client.id}).$promise.then(items => {
                $scope.contacts = items;
                return items;
            })
        }
    })

    .controller('OfferShowController', function ($scope, entity, $sce, modals, Offer, OfferStatus, PaymentDeadline, DeliveryMethod, ExecutionDeadline, PaymentMethod, Currency, Unit, Tax, toastr, OfferItem, Product,
                                                 $stateParams, OfferFormHelper, OfferPrintFieldsService) {
        $scope.offerId = $stateParams.id;
        $scope.offer = entity;

        $scope.OfferFormHelper = OfferFormHelper;
        $scope.OfferPrintFieldsService = OfferPrintFieldsService;
        $scope.defaultNewItem = {};

        $scope.refreshProducts = (q, language) => {
            Product.autocomplete(q, 100, language).then(items => $scope.products = items)
        }
        Tax.query().$promise.then(items => {
            $scope.taxRates = items
            $scope.defaultNewItem.taxRate = items.find(item => item.defaultValue === true)
        })
        Unit.list().$promise.then(items => {
            $scope.units = items
            $scope.defaultNewItem.unit = Unit.getDefault(items)
        })

        $scope.trustAsHtml = html => $sce.trustAsHtml(html)

        $scope.editItem = (offer, item) => item.old = angular.copy(item)
        $scope.cancelEditItem = (offer, item) => {
            if (item.old === true) {
                offer.items = offer.items.filter(val => val !== item)
            } else {
                angular.copy(item.old, item)
            }
            OfferFormHelper.recalculateOffer(offer)
        }

        $scope.saveItem = (offer, item) => {
            $scope.isSaving = true
            let $promise
            if (item.id) {
                $promise = OfferItem.update({id: offer.id}, item).$promise
            } else {
                $promise = OfferItem.save({id: offer.id}, item).$promise
            }
            return $promise.then(result => {
                    item.old = false
                    item = result
                    toastr.success("Zapisano")
                    $scope.isSaving = false
                })
                .catch(() => $scope.isSaving = false)
        }
        $scope.remove = (offer, item, index) => {
            return modals.confirmDelete(item.productName, () => {
                return OfferItem.remove({id: offer.id, item: item.id}).$promise
                    .then(() => {
                        offer.items.splice(index, 1)
                        OfferFormHelper.recalculateOffer(offer)
                    })
            })
        }
        $scope.sendEmail = offer => modals.open('app/offer/sendemail.tpl.html', 'OfferSendEmailController', offer, {size: 'lg'})
    })
    .controller('OfferSendEmailController', function ($scope, $rootScope, $uibModalInstance, $filter, data, Offer, OfferReportingService, MailPriority, IdentityService, toastr, Language, FilesLibrary) {
        $scope.iamsure = false;
        $scope.tinymceOptions = {
            height: 250,
            statusbar: false,
            plugins: "textcolor code table charmap",
            toolbar1: "undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | blockquote charmap | bullist numlist | outdent indent | table | forecolor backcolor | fontsizeselect | fontselect | code",
            toolbar2: "",
            toolbar_items_size: 'small',
        };

        $scope.offer = data;
        const contactEmail = data.contact && data.contact.type === 'EMAIL' ? data.contact.value : '';
        $scope.message = {
            address: contactEmail || "",
            topic: $filter("translate")('offer.email.topic') + " " + data.number,
            disposition_notification: false,
            dsn: false,
            files: [],
            priority: "LOW",
            lang: data.language
        };
        loadProductFiles(data, data.language);

        OfferReportingService.loadOfferTemplates().then(tpls => {
            $scope.templates = tpls
            $scope.message.tpl = tpls[0]
        })

        MailPriority.query().$promise.then(items => $scope.priorities = items)

        IdentityService.loadIdentities().then(items => {
            $scope.identities = items
            $scope.identityChange(items.find(val => val.defaultValue))
        })

        $scope.identityChange = identity => {
            if (angular.isUndefined(identity) === false) {
                $scope.message.identity = identity
                $scope.message.dsn = identity.dsn
                $scope.message.disposition_notification = identity.disposition_notification
                $scope.message.text = identity.signature
            }
        }

        $scope.attachFile = () => FilesLibrary.open().then(selectedFiles => $scope.message.files = $scope.message.files.concat(selectedFiles))

        $scope.deselectFile = $index => $scope.message.files.splice($index, 1)

        $scope.onLanguageChanged = language => {
            $scope.message.lang = language;
            loadProductFiles($scope.offer, language)
        }

        function loadProductFiles(offer, language) {
            OfferReportingService.getOfferFilesToSend(offer, language.code).then(files => $scope.message.files = files)
        }

        $scope.cancel = () => $uibModalInstance.dismiss('Canceled')

        $scope.send = (offer, message) => {
            $scope.iamsure = false
            $scope.sending = true
            OfferReportingService.sendOfferEmail(offer, message)
                .then(() => {
                    toastr.success("Wysłano email do " + message.address)
                    $uibModalInstance.close($scope.message)
                    $scope.sending = false
                })
                .catch(() => $scope.sending = false)
        }
    })
    .component('offerList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/offer/list.html',
        controller: function ($scope, $state, $stateParams, OfferService, OfferStatus) {
            this.OfferService = OfferService;
            this.reset = () => this.filters = {}
            this.$onInit = () => {
                OfferStatus.query().$promise.then(items => this.statuses = items)
            }
            $scope.$on('offer.updated', () => $state.reload())
        }
    })
    .directive('inlineEditDirective', function () {
        return {
            restrict: 'AE',
            require: '?content',
            scope: {
                content: '=',
                type: '='
            },
            templateUrl: "app/offer/inline-edit-directive.tpl.html",
            link: function (scope, $element, $attrs, ngModelCtrl) {

                scope.text = ""

                scope.editContent = content => {
                    scope.isEdit = true
                    scope.text = content
                }

                scope.cancelEdit = () => {
                    // angular.copy(scope.oldContent, scope.content);
                    scope.isEdit = false
                    scope.oldContent = undefined
                }

                scope.saveContent = () => {
                    scope.content = scope.text
                    scope.isEdit = false
                }
            }
        }
    })
    .run(function (NavbarLeftMenu) {
        NavbarLeftMenu.add({
            authorities: "ROLE_OFFER",
            path: "/offers",
            ico: "fa fa-fw fa-file-text-o",
            name: 'offer.menu',
            order: 60
        });
    })
    .config(function ($stateProvider) {
        $stateProvider.state('offerList', {
            parent: 'app',
            url: '/offers?{page:int}&{size:int}&sort&search&periodStart&periodEnd&{client:int}&{type:int}&status',
            params: {
                status: { array: true, squash: false },
            },
            data: {
                authorities: ['ROLE_OFFER']
            },
            views: {
                'content@': "offerList"
            },
            resolve: {
                page: (Offer, $stateParams) => Offer.table(angular.copy($stateParams)).$promise,
                filters: $stateParams => angular.copy($stateParams),
            }
        })
        $stateProvider.state('offerAdd', {
            parent: 'app',
            url: '/offers/add?client',
            data: {
                authorities: ['ROLE_OFFER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/offer/edit.tpl.html',
                    controller: 'OfferFormController',
                }
            },
            resolve: {
                entity: ($stateParams, Client) => {
                    let newOffer = {
                        dateOfIssue: moment().toDate(),
                        validTime: {
                            startDate: moment(),
                            endDate: moment().add(30, 'days')
                        },
                        saleProbability: 30,
                        status: "IN_PREPARATION",
                        id: null,
                        items: []
                    }
                    if ($stateParams.client) {
                        Client.get({id: $stateParams.client}, result => newOffer.client = result)
                    }
                    return newOffer
                }
            }
        })
        $stateProvider.state('offerAddClone', {
            parent: 'app',
            url: '/offers/add/{id}/clone',
            data: {
                authorities: ['ROLE_OFFER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/offer/edit.tpl.html',
                    controller: 'OfferFormController',
                }
            },
            resolve: {
                entity: ($stateParams, Offer) => {
                    return Offer.get({id: $stateParams.id}).$promise
                        .then(result => {
                            result.id = null
                            result.number = null
                            result.status = "IN_PREPARATION"
                            result.updatedBy = null
                            result.createdBy = null
                            result.updatedTime = null
                            result.createdTime = null
                            result.dateOfIssue = moment()
                            result.validTime = {
                                startDate: moment(),
                                endDate: moment().add(30, 'days')
                            }
                            angular.forEach(result.items, item => item.id = null)
                            return result
                        })
                }
            }
        })
        $stateProvider.state('offerShow', {
            parent: 'app',
            url: '/offers/{id}',
            data: {
                authorities: ['ROLE_OFFER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/offer/show.tpl.html',
                    controller: 'OfferShowController',
                }
            },
            resolve: {
                entity: ($stateParams, Offer) => Offer.get({id: $stateParams.id}).$promise
            }
        })
        $stateProvider.state('offerEdit', {
            parent: 'app',
            url: '/offers/{id}/edit',
            data: {
                authorities: ['ROLE_OFFER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/offer/edit.tpl.html',
                    controller: 'OfferFormController',
                }
            },
            resolve: {
                entity: ($stateParams, Offer) => Offer.get({id: $stateParams.id}).$promise
            }
        })
    })
